import api from './api';
import type { AdminPermission } from '../types';

export const ADMIN_PERMESSI_LABELS: Record<AdminPermission, { label: string; description: string }> = {
  contenuti: {
    label: 'Contenuti & Homepage',
    description: 'Banner & Promo, ordinamento Homepage, Avvisi & News, Pagine Legali',
  },
  catalogo: {
    label: 'Catalogo & Magazzino',
    description: 'Gestione anagrafica Prodotti e Alert Stock',
  },
  resi_ordini: {
    label: 'Vendite & Ordini',
    description: 'Gestione RMA (resi), Ordini, Carrelli attivi e Spedizioni & Stock',
  },
  clienti: {
    label: 'Clienti',
    description: 'Anagrafica Clienti, Registrazioni, Condizioni Commerciali, Impersonazione',
  },
  abbinatore: {
    label: 'Abbinatore',
    description: "Gestione dell'Abbinatore V2 (compatibilità prodotti/macchine)",
  },
  segnalazioni: {
    label: 'Segnalazioni',
    description: 'Gestione delle segnalazioni di difformità',
  },
  sistema: {
    label: 'Sistema & Configurazione',
    description: 'Aggiornamenti dal gestionale, Configurazione generale, Email & Notifiche',
  },
  carriere: {
    label: 'Carriere',
    description: 'Gestione delle posizioni aperte pubblicate in "Lavora con noi"',
  },
};

export interface AdminTeamMember {
  userId: string;
  email: string;
  nome: string;
  cognome: string;
  permessiAdmin: AdminPermission[];
  attivo: boolean;
  createdAt?: string | null;
  lastLogin?: string | null;
}

export interface AdminTeamMemberCreate {
  email: string;
  password: string;
  nome: string;
  cognome: string;
  permessiAdmin: AdminPermission[];
}

export interface AdminTeamMemberUpdate {
  nome?: string;
  cognome?: string;
  permessiAdmin?: AdminPermission[];
  attivo?: boolean;
  password?: string;
}

export const adminTeamService = {
  async list(): Promise<AdminTeamMember[]> {
    const { data } = await api.get('/api/admin/team');
    return data;
  },
  async create(payload: AdminTeamMemberCreate): Promise<AdminTeamMember> {
    const { data } = await api.post('/api/admin/team', payload);
    return data;
  },
  async update(userId: string, payload: AdminTeamMemberUpdate): Promise<AdminTeamMember> {
    const { data } = await api.patch(`/api/admin/team/${userId}`, payload);
    return data;
  },
  async remove(userId: string): Promise<void> {
    await api.delete(`/api/admin/team/${userId}`);
  },
};
